import React, { useEffect } from 'react';
import _ from 'lodash';
import { useHistory } from 'react-router-dom';
import '../styles/Dashboard.scss';
import '../styles/_global.scss';
import c from '../helpers/constants';
import View from '../components/View';
import Button from '../components/Button';
import Card from '../components/Card';
import imgCarpet from './../assets/images/Carpet.png';
import imgVinyl from './../assets/images/Vinyl.png';
import imgLaminate from './../assets/images/Laminate.png';
import imgLVT from './../assets/images/LVT.png';
import imgCarpetTiles from './../assets/images/Carpet-Tiles.png';
import imgGrass from './../assets/images/Grass.png';
import imgMatting from './../assets/images/Matting.png';
import imgContractFloors from './../assets/images/Contract.png';
import imgScreed from './../assets/images/Screed.png';
import CardWide from '../components/CardWide';
import SearchBarFilter from '../components/SearchBarFilter';

import { getCustomer } from '../selectors/Customer';
import { useSelector, useDispatch } from 'react-redux';
import { fetchCustomer } from '../actions/Customer';
import { getCategoryImage } from '../helpers/functions';
import { getOrganisedOrders } from '../selectors/Order';
import { fetchOrders } from '../actions/Order';

const Dashboard = () => {
  const history = useHistory();
  const onNavigate = (code: string) => history.push({ pathname: c.APP_ROUTES.SEARCH, search: `productTypeCode=${code}` });
  const p = useSelector(getCustomer);
  const organisedOrders = useSelector(getOrganisedOrders);
  const finalOrders = _.chain(Object.keys(organisedOrders).sort((a, b) => parseInt(b) - parseInt(a))).take(3).value();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchCustomer());
    dispatch(fetchOrders());
  }, [dispatch]);


  const staticProducts = [
    { name: 'Carpet', image: imgCarpet, code: 'C' },
    { name: 'Vinyl', image: imgVinyl, code: 'V' },
    { name: 'Laminate', image: imgLaminate, code: 'N' },
    { name: 'Luxury Vinyl Tile', image: imgLVT, code: 'L' },
    { name: 'Carpet Tiles', image: imgCarpetTiles, code: 'T' },
    { name: 'Artificial Grass', image: imgGrass, code: 'G' },
    { name: 'Matting', image: imgMatting, code: 'Q' },
    { name: 'Contract Floors', image: imgContractFloors, code: 'E' },
    { name: 'Screed', image: imgScreed, code: 'B' },
  ];

  const onSearch = (term: string) => {
    history.push({ pathname: c.APP_ROUTES.SEARCH, search: `searchSelection=${term}` });
  };

  return (
        <View>
            <div className="container hero-categories-container">
                <div className="hero-section">
                    <div className="hero-section__title">
                        <h1 className="hero-section__title__header">
                            {_.startCase(_.toLower(p?.NAME))} Dashboard
                        </h1>
                        {/*<div className="hero-section__title__desc">*/}
                        {/*    <p>Your last order was 02/04/21</p>*/}
                        {/*    <p className="hero-section__title__desc__link mx-2">*/}
                        {/*        <u>View here</u>*/}
                        {/*    </p>*/}
                        {/*</div>*/}
                    </div>
                    <SearchBarFilter onSearch={onSearch}/>
                </div>

                <div className="categories">
                    <div className="categories__title">
                        <h3 className="subtitle ">Product Categories</h3>
                    </div>
                    <div className="row gy-4 categories__row ">
                        {staticProducts.map((prod) => (
                            <div key={prod.name} className="col-lg-4 col-md-6 col-sm-6 center-align">
                                <Card
                                    title={prod.name}
                                    onClick={() => onNavigate(prod.code)}
                                    imageUrl={getCategoryImage(prod.code)}
                                    imageAlt={prod.name}
                                />
                            </div>
                        ))}
                    </div>
                </div>
                <div className="categories-cta">
                    <Button onClick={() => history.push(c.APP_ROUTES.PRODUCTS)} text="View All"/>
                </div>
            </div>

            {/* Activities Section */}
            <div className="container-fluid activities pt-4">
                <div className="row">
                    <div className="col-lg-1 col-md-1"/>
                    <div className="col-lg-5 col-md-12 col-sm-12">
                        <div className="activities__latest">
                            <h3 className="subtitle">Latest Activities</h3>
                            {finalOrders?.map(o =>
                                <div key={o} onClick={() => history.push(c.APP_ROUTES.ORDERS)}><CardWide
                                orderNumber={o}
                                // @ts-ignore
                                date={_.first(organisedOrders[o])?.date_ordered}
                                checkedAlt="check"
                            /></div>)}

                            <div className="activities-cta pb-5">
                                <Button text="View All" onClick={() => history.push(c.APP_ROUTES.ORDERS)}/>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-6 col-md-12 col-sm-12 activities-details">
                        <h3 className="pb-4">Business Details</h3>
                        <p className="pb-3">{_.startCase(_.toLower(p?.NAME))}</p>

                        <div className="row">
                            <div className="col-6">
                                <p>{_.startCase(_.toLower(p?.address_1))}</p>
                                <p>{_.startCase(_.toLower(p?.address_2))}</p>
                                <p>{_.startCase(_.toLower(p?.town))}</p>
                                <p>{_.startCase(_.toLower(p?.county))}</p>
                                <p>{p?.pcode}</p>
                            </div>
                        </div>
                        <h3 className="py-4">Contact Details</h3>
                        <div className="row pb-4">
                            <div className="col-6">
                                <p>{_.startCase(_.toLower(p?.contact_name))}</p>
                                <p>{p?.contact_mob}</p>
                                <p>{p?.contact_tel}</p>
                                <p>{p?.contact_email}</p>
                            </div>
                        </div>

                        <Button text="Request Update"/>
                    </div>

                </div>
            </div>
            <br />
            <br />
            <br />

            {/* Payments Section */}
            {/*<div className="payments container">*/}
            {/*    <div className="row payments__row">*/}
            {/*        <div className="col-lg-4 col-md-12 col-sm-12">*/}
            {/*            <h3 className="subtitle pb-3">Last Payments</h3>*/}
            {/*            <p className="pb-4">*/}
            {/*                Donec id elit non mi porta gravida at eget metus. Maecenas*/}
            {/*                faucibus.*/}
            {/*            </p>*/}
            {/*            <Button text="View All"/>*/}
            {/*        </div>*/}
            {/*        <div className="col-lg-8 col-md-12 col-sm-12">*/}
            {/*            <div className="row">*/}
            {/*                <div className="col-lg-6 col-md-12 col-sm-12">*/}
            {/*                    <CardSmall*/}
            {/*                        orderID="#01345"*/}
            {/*                        status="Overdue"*/}
            {/*                        date="10/02/21"*/}
            {/*                        amount="£000.00"*/}
            {/*                        color="#E22929"*/}
            {/*                    />*/}
            {/*                </div>*/}
            {/*                <div className="col-lg-6 col-md-12 col-sm-12">*/}
            {/*                    <CardSmall*/}
            {/*                        orderID="#01345"*/}
            {/*                        status="Overdue"*/}
            {/*                        date="10/02/21"*/}
            {/*                        amount="£000.00"*/}
            {/*                        color="#E22929"*/}
            {/*                    />*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}
        </View>
  );
};

export default Dashboard;
